import { FileOutlined, FileProtectOutlined } from '@ant-design/icons';
import { useDeleteFrontRichiesteIdModuliIdSezioniIdFileCodice } from '@framework/api-client';
import { useTranslation } from '@framework/i18n';
import { ButtonDeleteConfirm, FileRow } from '@framework/ui';
import { message, UploadFile } from 'antd';
import React from 'react';
import { WidgetDownloadButton } from '../download/WidgetDownloadButton';
import { PreviewSubmissionImageAttachment } from './PreviewSubmissionImageAttachment';

export interface IUploadedFileRowProps {
  file: UploadFile | undefined;
  submissionId: string | null | undefined;
  submissionModuleId: string | null | undefined;
  sectionId: string | null | undefined;
  readonly?: boolean;
  code: string;

  reset: () => void;

  isImage?: boolean | null;
  isFileSigned?: boolean;
  omissis?: boolean;

  extra?: React.ReactNode;
}

export function UploadedFileRow(props: IUploadedFileRowProps) {
  const {
    file,
    submissionId,
    submissionModuleId,
    sectionId,
    code,
    reset,
    readonly,
    isFileSigned,
    omissis,
    extra,
    isImage,
  } = props;

  const { t } = useTranslation();
  const remove = useDeleteFrontRichiesteIdModuliIdSezioniIdFileCodice();
  const areIdsDefined = !!submissionId && !!submissionModuleId && !!sectionId;

  if (!file) return null;

  const iconFile = isFileSigned ? (
    <FileProtectOutlined aria-hidden="true" />
  ) : (
    <FileOutlined aria-hidden="true" />
  );

  return (
    <FileRow
      file={file}
      icon={
        isImage ? (
          <PreviewSubmissionImageAttachment
            submissionId={submissionId ?? ''}
            attachmentId={file.uid}
            borderRadius={8}
            width={40}
            height={40}
          />
        ) : (
          iconFile
        )
      }
      downloadButton={
        areIdsDefined ? (
          <WidgetDownloadButton
            submissionId={submissionId}
            submissionModuleId={submissionModuleId}
            sectionId={sectionId}
            code={code}
            id={file.uid}
            filename={file.name}
            omissis={omissis}
          />
        ) : undefined
      }
      deleteButton={
        !readonly && areIdsDefined ? (
          <ButtonDeleteConfirm
            title={t(
              'uploaded-file-row.button-delete-confirm.title',
              'Sei sicuro di voler rimuovere il file?',
            )}
            buttonProps={{
              'aria-label': t(
                'uploaded-file-row.button-delete-confirm.button-aria-label',
                'Elimina file',
              ),
            }}
            buttonDanger
            iconOnlyButton
            size="small"
            loading={remove.isLoading}
            onConfirm={() => {
              remove
                .mutateAsync({
                  id: submissionId,
                  codice: code,
                  idRichiestaModulo: submissionModuleId,
                  idSezione: sectionId,
                  params: {
                    omissis: omissis,
                    idAllegato: file.uid ?? undefined,
                  },
                })
                .then(() => {
                  reset();
                })
                .catch((e: any) => {
                  if (e.response?.status === 404) {
                    // Il file non è stato trovato, possiamo dunque rimuoverlo
                    // dalla lista dei file caricati
                    reset();
                    return;
                  }
                  console.error('[RemoveFile] Error after API', { error: e });
                  message.error('Errore durante la rimozione del file');
                });
            }}
          />
        ) : undefined
      }
      extra={extra}
    />
  );
}
